import React, { useEffect } from "react"
import env from "@beam-australia/react-env"
import { loadScriptByURL } from "../modules/recaptcha"

export const Root = React.forwardRef(
    (props: React.HTMLProps<HTMLDivElement>, ref: React.LegacyRef<HTMLDivElement> | undefined) => {
        const { id, className, children } = props

        useEffect(() => {
            // load the script by passing the URL
            loadScriptByURL(
                "recaptcha-key",
                `https://www.google.com/recaptcha/api.js?render=${env("RECAPTCHA_SITE_KEY")}`,
                () => {
                    /**/
                }
            )
        }, [])

        return (
            <div data-testid={id} id={id} className={`${className ? className : ""}`} ref={ref}>
                {children}
            </div>
        )
    }
)
